module.exports = __webpack_public_path__ + "static/aboutt-d57b8a81a457d26dd3b093bfe9a36bb0.svg";